



























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxDateBox } from 'devextreme-vue';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract
} from '@/core/contracts';

import { Page } from '@/core/components/controls';
import { TableOptions, getTableCaption } from '@/core/components/table';
import { SettingsState } from '@/store';
import { DateTime, Duration } from 'luxon';
import { download } from '@/core/helpers/utils';

@Component({
    components: {
        TableOptions,
        DxDateBox,
    },
})
export default class GroupIndicatorsValue extends Page {
    public table: any = null;
    public processing: boolean = false;

    public editInternalStartTimeValue: any = null;
    public editInternalFinishTimeValue: any = null;

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;

    public async mounted() {
        this.setDefaultEditValues();
    }

    public get tableKey(): string {
        return 'group-indicators-value-control';
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    public setProcessing(isProcessing: boolean) {
        this.processing = isProcessing;
    }

    public exportXls() {
        const startTime = this.getStartTime();
        const finishTime = this.getFinishTime();
        const url = '/api/v2/contexts/reports/periodic-group-indicators-xlsx?' +
            'startTime=' + startTime + '&finishTime=' + finishTime;
        this.processing = true;
        download(url, 'report.xlsx').then(() => { this.processing = false; });
    }

    private getDateTimeAsString(value: any, uphours: boolean) {
        if (value != null) {
            const offset = SettingsState.contextSettings.global.timeOffset || 0;
            let time = DateTime.fromISO(new Date(value).toISOString());
            time = uphours
                ? time.plus(Duration.fromObject({ hours: offset }))
                : time.minus(Duration.fromObject({ hours: offset }));
            const strValue = time.toFormat('yyyy-MM-dd\'T\'HH:mm:ss');
            return strValue;
        }
        return null;
    }

    private getStartTime() {
        return this.getDateTimeAsString(this.editInternalStartTimeValue, false) + 'Z';
    }

    private getFinishTime() {
        return this.getDateTimeAsString(this.editInternalFinishTimeValue, false) + 'Z';
    }

    private async setDefaultEditValues() {
        this.editInternalStartTimeValue = null;
        this.editInternalFinishTimeValue = null;

        const url = '/contexts/reports/periodic-group-indicators-times';
        const data = await this._fetchService!.get<string[]>(url);
        this.editInternalStartTimeValue = this.getDateTimeAsString(data[0], true);
        this.editInternalFinishTimeValue = this.getDateTimeAsString(data[1], true);
    }
}
